'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElCitySelect = {
  name: 'ElCitySelect',
  componentName: 'ElCitySelect',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    keyName: {
      type: String,
      default: 'districtCode'
    },
    level: {
      type: Number,
      default: 3,
      validator: function validator(val) {
        return [1, 2, 3].includes(val);
      }
    }
  },
  data: function data() {
    return {
      options: []
    };
  },

  computed: {
    filteredOptions: function filteredOptions() {
      return this.filterChildren(this.options, this.level - 1);
    }
  },
  methods: {
    filterChildren: function filterChildren(options, level) {
      var _this = this;

      return options.reduce(function (ret, option) {
        var filteredOption = {
          label: option.label,
          value: option.value
        };

        if (level) {
          filteredOption.children = _this.filterChildren(option.children, level - 1);
        }
        return [].concat((0, _toConsumableArray3.default)(ret), [filteredOption]);
      }, []);
    },
    getData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return _api2.default.getAll();

              case 3:
                _context.t1 = _context.sent;

                _context.t0.createOptions.call(_context.t0, _context.t1);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _ref.apply(this, arguments);
      }

      return getData;
    }(),
    createOptions: function createOptions(data) {
      var _this2 = this;

      this.options = data.provinceList.map(function (province) {
        return {
          label: province.name,
          value: province[_this2.keyName],
          children: province.directCityList.map(function (city) {
            var child = {
              label: city.name,
              value: city[_this2.keyName],
              children: city.districtList.concat(city.lowerCityList).map(function (district) {
                return {
                  label: district.name,
                  value: district[_this2.keyName]
                };
              })
            };

            if (!child.children.length) {
              child.children = [{
                label: city.name,
                value: city[_this2.keyName]
              }];
            }
            return child;
          })
        };
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  render: function render() {
    var h = arguments[0];

    return h(
      'el-cascader',
      (0, _babelHelperVueJsxMergeProps2.default)([{
        attrs: { options: this.filteredOptions, value: this.value
        }
      }, { props: this.$attrs, on: this.$listeners }]),
      []
    );
  }
};

// mixin from API methods
(0, _assign2.default)(ElCitySelect, _api2.default);

exports.default = ElCitySelect;


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/city-select/src/city-select.js
// module id = 294
// module chunks = 0